module.exports = __webpack_public_path__ + "img/logoes.c186c8b0.png";